import React from "react";
import { toMobileImageUrl } from "../../functions/to-mobile-image";

export default class Picture extends React.Component {
    render() {
        const { src, alt, cls, ...otherProps } = this.props;
        return (
            <picture>
                <source media="(min-width: 641px)" srcSet={src} />
                <source media="(max-width: 640px)" srcSet={toMobileImageUrl(src)} />
                <img src={src} alt={alt || 'picture'} className={cls || ''} {...otherProps} />
            </picture>
            
        );
    }
}